import { Component } from '@angular/core';

@Component({
  selector: 'app-mediaactions',
  templateUrl: './mediaactions.component.html',
  styleUrl: './mediaactions.component.scss',
})
export class MediaactionsComponent {
  events = [
    {
      id: 1,
      title: 'منتدى رؤساء هيئات ترويج الاستثمار الأفريقية',
      description:
        'تحت رعاية السيد الدكتور مصطفى مدبولي رئيس مجلس الوزراء تنظم الهيئة العامة للاستثمار والمناطق الحرة الدورة الأولى لمنتدى رؤساء هيئات ترويج الاستثمار الأفريقية وذلك في الفترة من 11-14 يونيو المقبل بمدينة شرم الشيخ بحضور وزراء الاستثمار ورؤساء هيئات الاستثمار من 33 دولة أفريقية، وعدد من ممثلي التكتلات والمؤسسات الاقتصادية الدولية والأفريقية.',
      dateStart: '11 يونيو 2021',
      dateEnd: '14 يونيو 2021',
      location: 'شرم الشيخ',
      image: '/assets/media/uk-africa.jpg',
      fullDescription: `تحت رعاية السيد الدكتور مصطفى مدبولي رئيس مجلس الوزراء تنظم الهيئة العامة للاستثمار والمناطق الحرة الدورة الأولى لمنتدى رؤساء هيئات ترويج الاستثمار الأفريقية وذلك في الفترة من 11-14 يونيو المقبل بمدينة شرم الشيخ بحضور وزراء الاستثمار ورؤساء هيئات الاستثمار من 33 دولة أفريقية، وعدد من ممثلي التكتلات والمؤسسات الاقتصادية الدولية والأفريقية، وشخصيات رفيعة المستوى من مجال الأعمال من المصريين والأفارقة ، بهدف تحفيز الاستثمار في القارة الأفريقية`,
    },
    {
      id: 2,
      title: 'قمة الاستثمار في المملكة المتحدة وأفريقيا',
      description:
        'في 20 يناير 2020 ، استضافت المملكة المتحدة قمة الاستثمار البريطانية الأفريقية في لندن.',
      dateStart: '20 يناير 2020',
      dateEnd: '30 يناير 2020',
      location: 'المملكة المتحدة,لندن',
      image: '/assets/media/uk-africa.jpg',
      fullDescription: `في 20 يناير 2020 ، استضافت المملكة المتحدة قمة الاستثمار البريطانية الأفريقية في لندن. جمعت القمة الشركات والحكومات والمؤسسات الدولية لعرض وتعزيز فرص الاستثمار في جميع أنحاء أفريقيا.`,
    },
  ];

  selectedEvent: any = null;

  selectEvent(event: any) {
    this.selectedEvent = event;
    // Scroll to top
    window.scrollTo(0, 0);
  }

  clearSelection() {
    this.selectedEvent = null;
  }
}
